// extracted by mini-css-extract-plugin
module.exports = {"socialBtns":"socialIcons_socialBtns__3f7Ce","socialIconCircle":"socialIcons_socialIconCircle__vMzev","socialIcon":"socialIcons_socialIcon__1iRlg"};